export enum apiVersion {
	v1 = '1.0'
}
